<template>
	<div class="pageWrapper">
		<el-row>
			<el-col :span="10">
				<div class="panel actionPanel loginPage">
					<img class="logo" src="../assets/primaryLogo.svg" />
					<div class="loginForm">
						<h1 style="font-weight: bold">
							{{
								!redirectedFromUserCreation
									? username
										? "Welcome Back, " + username
										: "Welcome!"
									: username
										? "Welcome, " + username
										: "Welcome!"
							}}
						</h1>
						<p>Please enter your details to log in.</p>
						<div class="socialLoginSection"
							v-if="!oauthConfigLoading && (oauthConfig.googleEnabled || oauthConfig.microsoftEnabled)">

							<button type="button" class="gsi-material-button" @click="continueWithOAuth('google')"
								v-if="oauthConfig.googleEnabled">
								<div class="gsi-material-button-state"></div>
								<div class="gsi-material-button-content-wrapper">
									<div class="gsi-material-button-icon">
										<img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
											alt="Google" width="20" height="20" />
									</div>
									<span class="gsi-material-button-contents">
										Continue with Google
									</span>
								</div>
							</button>

							<button type="button" class="ms-login-button" @click="continueWithOAuth('microsoft')"
								v-if="oauthConfig.microsoftEnabled">
								<img src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
									alt="Microsoft" class="ms-icon" />
								<span>Continue with Microsoft</span>
							</button>

							<el-divider>OR</el-divider>
						</div>
						<el-alert v-if="socialLoginSuccess" :closable="false" style="margin-bottom: 12px"
							title="Login successful" description="Redirecting..." type="success" show-icon />
						<el-alert v-if="socialLoginError" :closable="false" style="margin-bottom: 12px"
							title="Login failed" :description="socialLoginErrorMessage" type="error" show-icon />
						<el-alert v-if="redirectedFromEmailVerification" :closable="false" style="margin-bottom: 12px"
							title="Your email has been succesfully verified" description="Please login" type="success"
							show-icon>
						</el-alert>
						<el-alert v-if="unauthorisedCreds" :closable="false" style="margin-bottom: 12px"
							title="Unable To Log In" :description="authErrorMessage" type="error" show-icon>
						</el-alert>
						<el-form ref="form" @keyup.native.enter="logIn" :rules="formRules" label-position="top"
							label-width="100px" :model="loginForm">
							<el-form-item prop="email" label="Email">
								<el-input type="email" placeholder="john.smith@acme.com"
									v-model="loginForm.email"></el-input>
							</el-form-item>
							<el-form-item prop="password" label="Password">
								<el-input placeholder="myPassword" type="password"
									v-model="loginForm.password"></el-input>
							</el-form-item>
							<el-form-item>
								<div style="text-align: right">
									<el-button @click="$router.push('/resetPasswordRequest')" type="text">Forgot
										password</el-button>
								</div>
							</el-form-item>
							<el-form-item>
								<el-button @click="logIn"
									:disabled="!loginForm.password || !loginForm.email || !emailIsValid ? true : false"
									style="width: 100%" type="primary" :loading="operationInProgress">Log In</el-button>
							</el-form-item>
							<el-form-item>
								<div style="text-align: center">
									Don't have an account?
									<el-button @click="$router.push('/signup')" style="position: relative"
										type="text">Sign up now <img class="underline"
											src="../assets/underline.svg" /></el-button>
								</div>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
			<el-col :span="14">
				<div class="panel contentPanel">
					<mediaCarousel />
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import Vue from "vue";
import mediaCarousel from "../components/mediaCarousel.vue";
import { mapActions, mapGetters } from "vuex";
let $this;
export default {
	computed: {
		...mapGetters(["isOtpSent"]),
	},
	components: {
		mediaCarousel,
	},
	data() {
		const validateEmail = function (rule, value, callback) {
			var re =
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(String(value).toLowerCase())) {
				callback(new Error("Please enter a valid email"));
				$this.emailIsValid = false;
			} else {
				callback();
				$this.emailIsValid = true;
			}
		};
		return {
			authErrorMessage: "Please enter valid credentials to log in",
			unauthorisedCreds: false,
			redirectedFromEmailVerification: false,
			redirectedFromUserCreation: false,
			operationInProgress: false,
			username: Vue.$cookies.get("username") || null,
			loginForm: { email: "", password: "" },
			emailIsValid: false,
			socialLoginSuccess: false,
			socialLoginError: false,
			socialLoginErrorMessage: "",
			oauthConfig: null,
			oauthConfigLoading: true,
			formRules: {
				email: [
					{ required: true, message: "Your email is required", trigger: "change" },
					{ validator: validateEmail, trigger: "change" },
				],
				password: [{ required: true, message: "Your password is required", trigger: "change" }],
			},
		};
	},
	async mounted() {
		$this = this;
		const res = await this.httpHelper("RUNTIME", "GET", "security/oauth-config", {});
		this.oauthConfig = res?.response || { googleEnabled: false, microsoftEnabled: false };
		this.oauthConfigLoading = false;
	},
	beforeMount() {
		if (this.$route?.params?.username) {
			this.redirectedFromUserCreation = true;
			this.username = this.$route?.params?.username;
			this.loginForm.email = this.$route?.params?.email;
			this.emailIsValid = true;
		} else {
			if (this.$route?.params?.emailVerified) {
				this.redirectedFromEmailVerification = true;
			} else {
				this.redirectedFromEmailVerification = false;
			}
			this.redirectedFromUserCreation = false;
		}
	},
	methods: {
		...mapActions(["loginMETHOD"]),
		async logIn() {
			this.unauthorisedCreds = false;
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					this.operationInProgress = true;
					const result = await this.loginMETHOD(this.loginForm);
					setTimeout(() => {
						this.operationInProgress = false;
						if (this.isOtpSent) {
							this.$router.push("/otp").catch(() => { });
						} else {
							const errorMsg = result?.error?.response?.data?.error?.message;
							if (errorMsg) {
								this.authErrorMessage = errorMsg;
							} else {
								this.authErrorMessage = "Please enter valid credentials to log in";
							}
							this.unauthorisedCreds = true;
						}
					}, 500);
				} else {
					return;
				}
			});
		},
		continueWithOAuth(provider) {
			const width = 500;
			const height = 600;
			const left = window.screenX + (window.innerWidth - width) / 2;
			const top = window.screenY + (window.innerHeight - height) / 2;

			window.open(
				`${process.env.VUE_APP_RUNTIME_ENDPOINT}/security/oauth/${provider}?mode=login`,
				`${provider}Login`,
				`width=${width},height=${height},left=${left},top=${top}`
			);

			const messageHandler = (event) => {
				if (!event.data) return;

				if (event.data.type === "oauth_login_success") {
					const { tokens, user } = event.data;

					Vue.$cookies.set("refreshToken", tokens.refresh.token, tokens.refresh.expires);
					Vue.$cookies.set("refreshTokenExpiry", tokens.refresh.expires, tokens.refresh.expires);
					Vue.$cookies.set("accessToken", tokens.access.token, tokens.access.expires);
					Vue.$cookies.set("accessTokenExpiry", tokens.access.expires, tokens.access.expires);
					Vue.$cookies.set("email", user.email, "60d");
					Vue.$cookies.set("username", user.username, "60d");
					Vue.$cookies.set("orgName", user.organisationName, "60d");
					if (user?.workflowTourStatus) {
						Vue.$cookies.set("workflowTourStatus", user.workflowTourStatus, "60d");
					} else if (Vue.$cookies.get("workflowTourStatus") == null) {
						Vue.$cookies.set("workflowTourStatus", "false", "60d");
					}

					if (Vue.$cookies.get("workflowTourStatus") === "false") {
						localStorage.setItem("workflowTourStartRequested", "true");
					}

					this.socialLoginSuccess = true;

					setTimeout(() => {
						this.$router.push("/");
					}, 200);

					window.removeEventListener("message", messageHandler);
				}

				if (event.data.type === "oauth_error") {
					this.socialLoginError = true;
					this.socialLoginErrorMessage =
						event.data.message || "Login failed";

					window.removeEventListener("message", messageHandler);
				}
			};

			window.addEventListener("message", messageHandler);
		}
	},
};
</script>

<style scoped>
.pageWrapper {
	min-height: 100vh;
	width: 100vw;
	text-align: left;
}

.panel {
	height: 100vh;
	width: 100%;
}

.logo {
	height: 40px;
	margin-left: 20px;
	margin-top: 20px;
}

.actionPanel {
	background-color: white;
}

.contentPanel {
	background-color: #f5f7f9;
}

.loginForm {
	width: 70%;
	max-width: 400px;
	display: block;
	margin: auto;
	margin-top: 12%;
}

.underline {
	height: 8px;
	position: absolute;
	top: 35px;
	left: 0px;
}

.loginPage {
	overflow-y: auto;
	min-height: 100vh;
}

.loginPage::-webkit-scrollbar {
	display: none;
}
</style>
